import { useFilters } from "../useFilters";

/**
 * Hook spécifique pour gérer les filtres des prospects/visits
 * @param resetPageCallback - Fonction pour réinitialiser la pagination
 * @param techniciansList - Liste globale des techniciens (optionnel)
 * @param customersList - Liste globale des clients (optionnel)
 * @returns - Interface pour manipuler les filtres
 */
export function useProspectsFilters(
  resetPageCallback: () => void,
  techniciansList?: any[],
  customersList?: any[]
) {
  // Fonction pour transformer les filtres avant sérialisation
  const transformForSerialization = (filters: Partial<EasyTech.ProspectsFilterType>) => {
    const filtersCopy = { ...filters };

    // Traitement des dates
    if (filtersCopy.startDate) {
      filtersCopy.startDate = new Date(filtersCopy.startDate as any).toISOString() as any;
    }

    if (filtersCopy.endDate) {
      filtersCopy.endDate = new Date(filtersCopy.endDate as any).toISOString() as any;
    }


    return filtersCopy;
  };

  // Fonction pour transformer les filtres après désérialisation
  const transformForDeserialization = (decodedFilters: any): Partial<EasyTech.ProspectsFilterType> => {
    const filters = { ...decodedFilters };

    // Traitement des dates
    if (filters.startDate) {
      filters.startDate = new Date(filters.startDate) as any;
    }

    if (filters.endDate) {
      filters.endDate = new Date(filters.endDate) as any;
    }

    // On garde l'objet tel quel pour technician et customer

    return filters;
  };

  // Combine startDate et endDate en un seul objet dateRange pour l'affichage en badge unique
  // Pour les visites, le badge inclut l'heure (withTime)
  const transformForDisplay = (filters: Partial<EasyTech.ProspectsFilterType>): Record<string, any> => {
    const displayFilters: Record<string, any> = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (key !== "startDate" && key !== "endDate") {
        displayFilters[key] = value;
      }
    });

    if (filters.startDate || filters.endDate) {
      displayFilters.dateRange = {
        start: filters.startDate || null,
        end: filters.endDate || null,
        withTime: true
      };
    }

    return displayFilters;
  };

  return useFilters<EasyTech.ProspectsFilterType>(
    resetPageCallback,
    {
      transformForSerialization,
      transformForDeserialization,
      transformForDisplay
    }
  );
} 